/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { AppShare, CourseShareOptions, ShareOptions } from '../../types';

/**
 * 打开分享弹框
 * @param data
 */
export const openCourseShareDialog = (data: CourseShareOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openCourseShareDialog', 'openShareDialog');
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('openShareDialog', params, null);
};

/**
 * 调用客户端分享
 * @param data
 * @returns
 */
export const openShareDialog = (data: ShareOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openShareDialog', 'showShareDialog');
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('showShareDialog', params, null);
};

/**
 * 调用客户端打开课程弹框
 * @param data
 */
export const openShowCourseDialog = (url: string): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openShowCourseDialog', 'showCourseDialog');
    return;
  }
  bridgeCallHandler('showCourseDialog', url, null);
};

/**
 * 触发原生分享
 * @param data
 * @returns
 */
export const triggerAppShare = (data: AppShare): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('triggerAppShare', 'triggerAppShare');
    return;
  }

  bridgeCallHandler('triggerAppShare', JSON.stringify(data), null);
};
